import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface MarkDdNdaExecutedArg {
    engagementId: number;
    buyerId: number;
    file?: File;
}

export const MarkDdNdaExecuted = createAsyncThunk(
    'timeline/markDdNdaExecuted',
    async (arg: MarkDdNdaExecutedArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const formData = new FormData();
        formData.append('buyerId', String(arg.buyerId));
        if (arg.file) {
            formData.append('file', arg.file);
        }

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${arg.engagementId}/DdNda/MarkExecuted`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.status !== 200) {
                throw new Error('Failed to mark the DD NDA as executed');
            }
        } catch (error) {
            createNotification(
                'There was an error while marking the DD NDA as executed.',
                'error'
            );
            throw error;
        }
    }
);
